<ng-template #step1>
  <div class="dialog__body dialog__body--no-padding dialog__body--grow dialog__body--grey">
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Selfservice.Global.Title" | translate }}</h3>
      <p class="no-margin">{{ "Selfservice.GracefulRestart.Text" | translate }}</p>
    </div>

    <div class="dialog__rule">
      <h3 class="dialog__sub-heading">{{ "Selfservice.Global.CurrentSetting" | translate }} Graceful Restart</h3>
      <div class="dialog__rule-answer">{{ gracefulRestart() | enabled_or_value }}</div>
    </div>
    <div class="dialog__rule">
      <h3 class="dialog__sub-heading">{{ "Selfservice.Global.NewSetting" | translate }} Graceful Restart</h3>
      <div class="dialog__rule-answer blue">
        {{ newSetting() | enabled_or_value }}
      </div>
    </div>
  </div>
  <div class="dialog__bottom-message">
    <div class="dialog__bottom-message-inner">
      <svg-icon src="assets/images/icons/status-failure.svg" class="dialog__bottom-message-icon"></svg-icon>
      <span> {{ "Selfservice.GracefulRestart.Message" | translate }} </span>
    </div>
  </div>
</ng-template>

<selfservice-wizard [steps]="[step1]" [getCommand]="buildCommand" [bus]="bus()" />
